module.exports = __webpack_public_path__ + "img/menu-yaogan.9c843bb9.svg";